import { tierConsumerReduxKey } from './constants';
function getState(state) {
    if (!state[tierConsumerReduxKey]) {
        return {};
    }
    return state[tierConsumerReduxKey];
}
export var isConsumerReduxReady = function (state) { return getState(state).reduxReady; };
export var isMatureFilterOverridden = function (state, deviationId) { return (getState(state).matureFilterOverrides &&
    getState(state).matureFilterOverrides.includes(deviationId)); };
//# sourceMappingURL=selectors.js.map